import { lazy, Suspense } from 'react';
import SkeletonDiscussion from './SkeletonDiscussion';

const loader = () => import('./Discussion');
const Discussion = lazy(loader);

export const preloadDiscussionChunk = loader;

export default function DiscussionLazy(props) {
  return (
    <Suspense fallback={<SkeletonDiscussion />}>
      <Discussion {...props} />
    </Suspense>
  );
}